export default {
  progressMetadata: {
    buttons: {
      createDevPlan: 'Создать план развития',
    },
    tooltips: {
      progress: '% респондентов, которые оценили ваши компетенции',
      closed: 'Оценка была закрыта организатором.',
      license: 'Для запуска тестов и получения лицензий обратитесь к организатору',
      notAvailable: 'Для запуска тестов обратитесь к организатору',
    },
    stubs: {
      noSkills:
        'Для прохождения самооценки выберите специализацию. Для этого нажмите на кнопку «Изменить»',
      noTests: 'Не было назначено ни одной оценки, где вам необходимо оценить ваших коллег',
      selfApproval:
        'Здесь будет отображаться список тестов на согласовании, в которых вы сможете скорректировать состав участников оценки и отправить оценку на согласование руководителя.',
      notSelfApproval:
        'Здесь будет отображаться список тестов на согласовании, в которых вы сможете скорректировать состав участников, запустить или отклонить оценку по тесту 360.',
      feedback:
        'Не было назначено ни одного опроса, где вам необходимо дать обратную связь вашим коллегам',
    },
    // dialogs
    infoDialog: {
      title: 'Согласование не требуется',
      text: 'Данный тест больше не требует согласования, он был закрыт, отменён или уже запущен, если необходимо узнать подробности, обратитесь к вашему организатору оценки.',
    },
    selectBlockSelfTestingDialog: {
      description:
        'Оцените свои знания по каждой из перечисленных компетенций, нажав кнопку «Пройти оценку». После оценки всех компетенций будет сформирован отчёт.',
    },
    selectBlockTesting360Dialog: {
      description:
        'Для старта оценки выберите блоки для оценки навыков.</br> В форме оценки выбирайте наиболее подходящий вариант ответа для каждого вопроса.</br> Ответы автоматически сохраняются после завершения каждого блока.</br> После того как вы дадите ответы на все вопросы в анкете, оценка будет завершена.',
      additionalInfo: {
        form: 'В форме отображаются значения по предыдущим оценкам.',
        youCan: 'Вы можете:',
        first: 'пройти оценку повторно, чтобы актуализировать ваш уровень компетенций,',
        second:
          'или завершить оценку без прохождения, если уровень ваших компетенций с предыдущей оценки не изменился.',
      },
    },
    selectTestPersonalDialog: {
      description:
        'Вам предстоит пройти тестирование. Основная цель данного тестирования заключается в выявлении ваших сильных сторон и зон развития.',
      subtitle: 'Тестирование состоит из',
      annotation: {
        title: 'Тестирование займет около 40 минут',
        text: '<p>Убедитесь, что вы хорошо себя чувствуете и позаботьтесь о том, чтобы вас ничего не отвлекало.</p><p>Нажмите кнопку «{button}» для того, чтобы приступить к&nbsp;тестированию.</p>',
      },
    },
    // confirm dialogs
    confirmStartTesting: {
      title: 'Начать тест?',
      text: 'Лицензия списывается в момент начала прохождения теста. Вы можете прервать тестирование в любой момент, закрыв окно тестирования, и продолжить прохождение теста позже.',
      button: 'Да, начать',
    },
    confirmContinueTesting: {
      title: 'Продолжить тест?',
      text: 'Будет продолжен прерванный сеанс тестирования. Лицензия за этот тест уже была списана ранее.',
      button: 'Да, продолжить',
    },
    confirmGetReport: {
      title: 'Сформировать отчет?',
      text: 'Не все участники теста заполнили опросник, полученные данные могут оказаться недостоверными.',
      button: 'Да, сформировать',
    },
    confirmCreateRoadmap: {
      title: 'Сформировать план развития?',
      text: 'Сформировать план развития на основе этого теста',
      button: 'Да, сформировать',
    },
    // messages
    successMessages: {
      saveResults: {
        title: 'Тест завершён',
        defaultText: 'Ваши ответы сохранены. Благодарим за уделённое время!',
        hiddenReportText:
          'Результаты опроса будут обсуждаться на индивидуальной встрече с руководителем, как только все опросы будут обработаны.',
      },
    },
    errorMessages: {
      getBHPersonalBlock: 'Не удалось перейти на страницу тестирования',
      getVariantsPersonalReport: 'Не удалось получить варианты отчётов',
      getUrlPersonalTest: 'Не удалось запустить сеанс тестирования',
      getLinkPersonalReport: 'Не удалось получить ссылку на отчёт',
      createReport: 'Не удалось сформировать отчёт',
      createRoadmap: 'Не удалось сформировать план развития',
      saveResults: 'Не удалось сохранить ответы',
    },
  },
};
